import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";

import "../../stylesheets/calendar.scss";
import PreviousResponse from '../previous-response/previous_response.jsx';

export const DateInput = ({ label, onValueChange, initValue, lastSurveyResponseHeader, lastSurveyResponseText }) => {
  const [calendarValue, setCalendarValue] = useState(null);
  const [date, setDate] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const today = new Date();

  useEffect(() => {
    if (initValue && initValue !== "") {
      const dateMatch = initValue.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (dateMatch) {
        const parsedDate = new Date(
          dateMatch[3],
          dateMatch[2] - 1,
          dateMatch[1]
        );
        if (parsedDate <= today) {
          setCalendarValue(parsedDate);
          setDate(initValue);
        }
      }
    }
  }, [initValue]);

  const formatNumber = (num) => {
    if (num < 10) {
      return "0" + num;
    } else {
      return "" + num;
    }
  };

  const handleChange = (value) => {
    if (value > today) return;
    const dateValue = `${formatNumber(value.getDate())}/${formatNumber(
      value.getMonth() + 1
    )}/${value.getYear() + 1900}`;

    setCalendarValue(value);
    setDate(dateValue);
    setShowCalendar(false);
    onValueChange({ key: 0, value: dateValue });
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (/^\d{0,2}\/?\d{0,2}\/?\d{0,4}$/.test(inputValue)) {
      setDate(inputValue);
    }
    setShowCalendar(false);
  };

  const handleBlur = () => {
    if (date === "") {
      setCalendarValue(null);
      onValueChange({ key: 0, value: "" });
      return;
    }

    const dateMatch = date.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (dateMatch) {
      const parsedDate = new Date(dateMatch[3], dateMatch[2] - 1, dateMatch[1]);
      if (!isNaN(parsedDate) && parsedDate <= today) {
        setCalendarValue(parsedDate);
        onValueChange({ key: 0, value: date });
        return;
      }
    }

    setDate(
      calendarValue
        ?  `${formatNumber(calendarValue.getDate())}/${formatNumber(
            calendarValue.getMonth() + 1
          )}/${calendarValue.getYear() + 1900}`
        : ""
    );
  };

  return (
    <div
      className="date-input"
      style={{ marginBottom: "25px", marginTop: "25px" }}
    >
      <p
        className="title"
        style={{ "fontSize": "20px", "marginBottom": "10px", "textAlign": "left" }}
      >
      {label + ' (DD/MM/YYYY)'}
      </p>
      {
          lastSurveyResponseText && (
            <PreviousResponse
              responseHeader={lastSurveyResponseHeader}
              responseText={lastSurveyResponseText}
            />
          )
        }
      <div
        className="calendar-input-field"
        style={{
          "backgroundColor": "#e4e4e4",
          "height": "40px",
          "borderRadius": "5px",
          "display": "flex",
          "alignItems": "center",
          "position": "relative",
        }}
      >
        <input
          className="input"
          onClick={() => setShowCalendar(!showCalendar)}
          onChange={handleInputChange}
          onBlur={handleBlur}
          style={{
            "height": "32px",
            "display": "block",
            "color": "rgba(0, 0, 0, 0.87)",
            "border": "none",
            "outline": "0",
            "width": "100%",
            "boxSizing": "border-box",
            "fontSize": "16px",
            "padding": "8px 30px 0px 10px",
            "backgroundColor": "transparent",
            "textAlign": "inherit",
            "zIndex": "3",
            "position": "relative",
            "letterSpacing": "1px",
          }}
          type="text"
          value={date}
          placeholder="DD/MM/YYYY"
        />
      </div>
      {showCalendar && (
        <div className="calendar-wrapper">
          <Calendar
            maxDate={new Date()}
            onChange={handleChange}
            value={calendarValue}
          />
        </div>
      )}
    </div>
  );
};
